import React, { useState, useEffect, useCallback, useRef } from 'react';
import { AiOutlineLine } from 'react-icons/ai';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Img from 'gatsby-image';
import usePartnerSectionData from './dataQuery';
import { PartnerSectionContent } from './styles';
import { SharpImage } from '../../../interfaces/SharpImage';

interface LogosProps {
  id: number;
  logos: Array<{ image: SharpImage }>;
}

export const PartnerSectionComponent = () => {
  const logosRowRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState<LogosProps>({
    id: 0,
    logos: [],
  });

  const { partners, labels } = usePartnerSectionData();

  const handleScroll = useCallback((action) => {
    const currentRef = logosRowRef.current;
    const scrollPositon = currentRef.scrollLeft;

    switch (action) {
      case 'reset':
        currentRef.scrollTo(0, 0);
        break;
      case 'scrollToLeft':
        currentRef.scrollTo(scrollPositon - 300, 0);
        break;
      case 'scrollToRight':
        currentRef.scrollTo(scrollPositon + 500, 0);
        break;
      default:
    }
  }, []);

  const toggleCategory = useCallback((id) => {
    const { logos } = partners.find((el, index) => index === id);
    setSelectedCategory({ id, logos });
    handleScroll('reset');
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const { id } = selectedCategory;
      toggleCategory(id === 4 ? 0 : id + 1);
    }, 4000);

    return () => {
      clearTimeout(timer);
    };
  }, [toggleCategory, selectedCategory.id]);

  useEffect(() => {
    toggleCategory(0);
  }, []);

  return (
    <PartnerSectionContent>
      <section className="partners-network">
        <div className="container">
          <h2>Confira alguns dos <b>principais parceiros</b></h2>
          <div className="column is-12 categories-row">
            {labels &&
              labels.map((el, index) => (
                <div className="is-flex" key={`fragment${index}`}>
                  <div
                    className={`category-control ${selectedCategory.id === el.id ? 'is-active' : ''}`}
                    key={el.id}
                    onClick={() => toggleCategory(el.id)}
                  >
                    <p>{el.title}</p>
                    <span className="highlight">{el.offer}</span>
                  </div>
                  {labels.length - 1 !== index && <AiOutlineLine />}
                </div>
              ))}
          </div>
          <div className="column is-12 partners-box">
            <div className="column is-1 control-box left">
              <div className="arrow-box left" onClick={() => handleScroll('scrollToLeft')}>
                <FaChevronLeft />
              </div>
            </div>
            <div className="logos-row column is-12" ref={logosRowRef}>
              {selectedCategory.logos &&
                selectedCategory.logos.map((el, index) => (
                  <div className="logo-box" key={index}>
                    <Img className="logo" fixed={el.image.childImageSharp.fixed} alt="logo-customer" />
                  </div>
                ))}
            </div>
            <div className="column is-1 control-box right">
              <div className="arrow-box right" onClick={() => handleScroll('scrollToRight')}>
                <FaChevronRight />
              </div>
            </div>
          </div>
        </div>
      </section>
    </PartnerSectionContent>
  );
};

export default PartnerSectionComponent;
